import { CategorizedHPOOption } from '@/types/RequisitionFormTypes'
import { extractHPOId } from './hpoTypes'

export type GetHPOTermById = (id: string) => Promise<{ id: string; lbl: string } | null>

/**
 * Updates HPO term labels by fetching the latest label from the HPO API.
 *
 * @param terms - Array of categorized HPO options to update
 * @param getTermById - Async function to resolve HPO id to { id, lbl }
 * @returns Promise resolving to an array of updated categorized HPO options with fresh labels
 */
export async function updateHPOTermLabels(
  terms: CategorizedHPOOption[],
  getTermById: GetHPOTermById
): Promise<CategorizedHPOOption[]> {
  return Promise.all(
    terms.map(async (term) => {
      const resolved = await getTermById(term.id)
      if (resolved) {
        return {
          ...term,
          id: extractHPOId(resolved.id),
          label: resolved.lbl,
          node: { id: extractHPOId(resolved.id), lbl: resolved.lbl },
        }
      }
      return term
    })
  )
}
